export const OPTHINES = {
  voteName: '2020project/2020civilized',
  themeColor: {
    activeBgColor: 'rgb(220,229,176)',
    inactiveBgColor: 'rgb(134,149,99)',
  },
  mustSearch: 'Button',
  buttonBg: '#d83334',
  placeholder: '输入名字进行搜索',
  name: true,
  tickets: {
    textFirst: '票数',
  },
  tabs: [
    {
      tabName: '活动首页',
      tabPath: '/20200401GYGG/List',
    },
    {
      tabName: '我要报名',
      tabPath: '/20200401GYGG/register',
    },
    {
      tabName: '活动简介',
      tabPath: '/20200401GYGG/rules',
    },
  ],
};
